module.exports = __webpack_public_path__ + "media/e_m.df564e48.mp3";